<template>
  <!-- 来訪者一覧 -->
  <v-form ref="p1Form" v-model="p1Form" lazy-validation>
    <v-container>
      <v-card class="gridlist">
        <v-card-text>
          <v-row>
            <v-col>
              <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
              <v-form
                ref="tableForm"
                v-model="tableForm"
                lazy-validation
                @submit.prevent
              >
                <ryou-table
                  ref="ryouTable"
                  :rowKey="rowKey"
                  :headers="headers"
                  :queryParams="queryParam"
                  :url="url"
                  :businessKey="businessKey"
                  :dummy="false"
                  :needSearch="true"
                  :height="height"
                  :handleEdit="handleEdit"
                  :handleDelete="handleDelete"
                  :title="'来訪者一覧'"
                >
                  <v-row slot="filterContainer">
                    <v-col cols="8"> </v-col>
                    <v-col cols="2" class="addBtn">
                      <ryou-blue-btn
                        :label="'新規追加'"
                        :handlerClick="handleAdd"
                      ></ryou-blue-btn>
                    </v-col>
                  </v-row>
                </ryou-table>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <VisitorDialog ref="modalForm" @ok="modalFormOk" :url="url">
      </VisitorDialog>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </v-form>
</template>

<script>
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import VisitorDialog from "./modules/VisitorDialog.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";

export default {
  name: "Visitor",
  mixins: [RyouTableMixins],
  components: {
    RyouBlueBtn,
    RyouTable,
    VisitorDialog,
    RyouConfirm,
  },
  data() {
    return {
      p1Form: true,
      search: "",
      rowKey: "rowIndex",
      businessKey: "visit_seq_no",
      tableForm: true,
      cardIssu: "hidden",
      tableName: "ryouTable",
      dynamicItems: [], //コンボボックスのすべてのデータ
      headers: [
        {
          text: "来訪者名",
          value: "visit_name",
          class: "blue lighten-2 title",
          width: "15%",
          sortable: true,
          groupable: false,
        },
        {
          text: "来訪日時",
          value: "sh_input_date",
          class: "blue lighten-2 title",
          width: "20%",
          sortable: true,
          groupable: false,
        },
        {
          text: "来訪者備考",
          value: "visit_remark",
          class: "blue lighten-2 title",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "車両番号",
          value: "vehicle_no",
          class: "blue lighten-2 title",
          width: "15%",
          sortable: true,
          groupable: false,
        },
        {
          text: "訪問先",
          value: "user_name",
          class: "blue lighten-2 title",
          width: "20%",
          sortable: true,
          groupable: false,
        },
        {
          text: "用件",
          value: "visit_requirement",
          class: "blue lighten-2 title",
          width: "30%",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
        {
          value: "user_id",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
        {
          value: "visit_seq_no",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
      ],
      height: 578,
      types: ["success", "error", "warning", "info", "default"],
      url: {
        list: "/visitor/get",
        delete: "/visitor/delete",
        add: "visitor/insert",
        update: "/visitor/update",
      },
    };
  },
  created() {
    var _that = this;
    this.url.list = _that.url.list + this.initViewParams();
    // console.log(this.url.list);
    this.initData();
  },
  methods: {
    initViewParams() {
      //ビュー検索用URLパラメータ
      let params =
        "/" +
        this.$store.getters.getUserId +
        "/" +
        this.$store.getters.getUserClass;
      return params;
    },
    initData() {
      //寮生情報取得
    },
  },
};
</script>
